import io from "socket.io-client";
import { WEBSOCKET_ENDPOINT } from "@/setup/constants";

const socket = io(WEBSOCKET_ENDPOINT, {
  transports: ["websocket"]
  // autoConnect: false
});

export default socket;
